import { render, staticRenderFns } from "./DealersAddressDetails.vue?vue&type=template&id=1afb0489&scoped=true"
import script from "./DealersAddressDetails.vue?vue&type=script&lang=ts"
export * from "./DealersAddressDetails.vue?vue&type=script&lang=ts"
import style0 from "./DealersAddressDetails.vue?vue&type=style&index=0&id=1afb0489&lang=scss"
import style1 from "./DealersAddressDetails.vue?vue&type=style&index=1&id=1afb0489&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afb0489",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1afb0489')) {
      api.createRecord('1afb0489', component.options)
    } else {
      api.reload('1afb0489', component.options)
    }
    module.hot.accept("./DealersAddressDetails.vue?vue&type=template&id=1afb0489&scoped=true", function () {
      api.rerender('1afb0489', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dealers-addresses/components/DealersAddressDetails.vue"
export default component.exports